<template>
    <div id='mailTeaching'>
        <div class="head">
            <div class="pubw">
                <h2 class="h">寄件教學</h2>
                <div class="tabs">
                    <div class="item" v-for="item in tabList" :key="item.id" :class="tabActive == item.id?'active':''">
                        <h3 class="h" @click="changeTab(item.id)">{{item.title}}</h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="body">
            <div class="pubw">
                <div class="embargo" v-show="tabActive==3">
                    <div class="item" v-for="item in embargoList" :key="item.id">
                        <h2 class="tiltle">{{item.tittle}}</h2>
                        <div class="descriptions">
                            <span>
                                {{item.descriptions}}
                            </span>
                        </div>
                        <div class="links">
                           <div class="link" v-for="linkItem in item.links" :key="linkItem.id">
                                <a :href="linkItem.link">{{linkItem.title}}</a>
                           </div>
                        </div>
                        <div class="rows">
                            <div class="row"  v-for="rowItem in item.rows" :key="rowItem.id">
                                <li>{{rowItem.text}}</li>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="FQA" v-show="tabActive==4">
                    <div class="item" v-for="item in FQAList" :key="item.id">
                        <h2 class="tiltle">{{item.tittle}}</h2>
                        <el-row>
                            <el-col :span="4">
                                <div class="links">
                                    <div class="link" v-for="linkItem in item.links" :key="linkItem.id">
                                         <a :href="linkItem.link">{{linkItem.title}}</a>
                                    </div>
                                 </div>
                            </el-col>
                            <el-col :span="16">
                                <div class="rows">
                                    <div class="row"  v-for="rowItem in item.rows" :key="rowItem.id">
                                        <li>{{rowItem.text}}</li>
                                        <li class="subRow" v-for="subRow in rowItem.children" :key="subRow.id">
                                            {{subRow.text}}
                                        </li>
                                        <li v-if="rowItem.id == 333">
                                            如你的郵件包含任何禁運物品、未能提交快公司或當地海要求的設明文件,或寄件人虚報或未有如貴地申報寄件物品内容;當地海和快公司有權銷毀郵件,並向寄件
                                        人徵收罰款、手費、行政費,金額完全由海和快遗公司決定。
                                        </li>
                                        <li v-if="rowItem.id == 333">
                                            請於寄件前榱查你發送的郵件内容是否在禁運物品清單( insert link)更多收詳情・請参<a href="htps:/umppointio/o">htps:/umppointio/o</a>
                                        </li>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import optionsButton from '@/components/optionButton'
export default {
    name:'mailTeaching',
    props:["tabIndex"],
    components:{
        optionsButton,
    }, 
    data(){
        return {
            // tab列表
            tabList:[
                {
                    id:'1',
                    title:'電子產品'
                },
                {
                    id:'2',
                    title:'其他物品'
                },
                {
                    id:'3',
                    title:'禁運及限制物品'
                },
                {
                    id:'4',
                    title:'FAQ'
                }
            ],
            // 当前激活的tab栏
            tabActive:this.$route.params.tabIndex + '',
            // 禁运内容列表
            embargoList:[
                {
                    id:'0',
                    tittle:"電子產品",
                    descriptions:`此禁連品名單只供參考未能把所有禁運品一一盡録。而且各國海開及快公司的法例法規亦有所差異,如你對
寄出物品有任何疑問,歡迎向我們查詢。你布可於本港的的民航處及海事處網貢獲取更多資訊。`,
                    links:[
                        {
                            id:"0",
                            title:"香港民航處",
                            link:'119.23.107.209'
                        },
                        {
                            id:"1",
                            title:"香港海事處",
                            link:'119.23.107.209'
                        }
                    ],
                },
                {
                    id:'1',
                    tittle:"食品",
                    rows:[
                        {
                            id:"0",
                            text:`容易變壞或需冷藏的食物如易腐蝕食品・新鮮蔬果丶生鮮食品火腿等高價值/具交易功能。`
                        },
                        {
                            id:"1",
                            text:"非鑲嵌之寶石及半寶石"
                        },
                        {
                            id:"2",
                            text:"古董(易裂或及易碎的)、藝術品。"
                        },
                        {
                            id:"4",
                            text:"金條、任何貴金屬、現金合法流通之貨幣。"
                        },
                        {
                            id:"5",
                            text:"郵票、代幣、儲值卡、任何類型的門票、信用卡、借記卡或現金卡"
                        }
                    ]
                },
                {
                    id:'2',
                    tittle:"高價值/具交易功能",
                    rows:[
                        {
                            id:"0",
                            text:"非鑲嵌之石及半寶石"
                        },
                        {
                            id:"1",
                            text:"古董(易裂或及易碎的)、藝術品。"
                        },
                        {
                            id:"2",
                            text:"金條、任何貴金屬、現金、合法流通之貨幣。"
                        },
                        {
                            id:"4",
                            text:"郵票、代幣、儲值卡、任何類型的門票、信用卡、借記卡或現金卡。"
                        }
                    ]
                },
                {
                    id:'3',
                    tittle:"生物相關",
                    rows:[
                        {
                            id:"0",
                            text:"遺體、骨灰"
                        },
                        {
                            id:"1",
                            text:"活體動物。"
                        },
                        {
                            id:"2",
                            text:`動物狩獵戦利品及動物遺體包括象牙及其製品魚翅、或由瀕危野生動植物種國際貿易公約( CITES)、地方法
規所規定之禁運動物產製品包括不供人類食用的動物副產品及衍生產品如皮草等動物製成品`
                        },
                        {
                            id:"4",
                            text:"土壤樣本。"
                        }
                    ]
                },
                {
                    id:'4',
                    tittle:"受法例管制",
                    rows:[
                        {
                            id:"0",
                            text:"非法貨物如仿冒品假貨及毒品"
                        },
                        {
                            id:"1",
                            text:"色情物品"
                        },
                        {
                            id:"2",
                            text:"軍事設備如已装嵌之槍械・彈築、軍火、軍火相零組件、爆炸品與爆炸裝装置"
                        },
                        {
                            id:"4",
                            text:"受管制刀具、弩箭等。"
                        }
                    ]
                },
                {
                    id:'5',
                    tittle:"危險類",
                    rows:[
                        {
                            id:"0",
                            text:"所有藥品、健康食品、醫療用品"
                        },
                        {
                            id:"1",
                            text:"受潮或散發異常氣味的貨品"
                        },
                        {
                            id:"2",
                            text:"國際航空運輸協會(ATA)PI968 section II散装鋰金屬電池。"
                        },
                        {
                            id:"3",
                            text:"易燃物品如香水、酒精、香、指甲油油漆、汽油、天拿水等易液體。"
                        },
                        {
                            id:"4",
                            text:"氣體、壓縮、液化及受壓溶解的氣體,如髮膠、殺蟲劑丶氣霧劑、氣醴打火機"
                        },
                        {
                            id:"5",
                            text:"放射性或傳染性物質。"
                        },
                        {
                            id:"6",
                            text:"含冷媒商品,如冷氣"
                        }
                    ]
                }
            ],
            // FQA内容列表
            FQAList:[
                {
                    id:'0',
                    tittle:"如何追蹤我的貨物?",
                    descriptions:"此禁运品",
                    links:[
                        {
                            id:"0",
                            title:"Jumppoint",
                            link:'119.23.107.209'
                        },
                        {
                            id:"1",
                            title:"Freight Amigo",
                            link:'119.23.107.209'
                        },
                        {
                            id:"2",
                            title:'Shipto',
                            link:'119.23.107.209'
                        }
                    ],
                    rows:[
                        {
                            id:"0",
                            text:"完成寄件预約後・你可以於 jumppoint的手機應用程式内的「貨物追踪」查問寄件狀況。"
                        },
                        {
                            id:"1",
                            text:`您可以到“我的貨件”中的“貨件追踪和文件”進行實時跟蹤`
                        },
                        {
                            id:"3",
                            text:`或者使用我們連接了300多家航空公司和船公司的“貨件追”工具。只需輸入您的貨件編
/空運提單/集裝箱绵·即可實時追蹤貨物,節省您的寶貴時間`
                        },
                    ]
                },
                {
                    id:'1',
                    tittle:"郵件被寄失怎麽辦?",
                    links:[
                        {
                            id:"0",
                            title:"Jumppoint",
                            link:'119.23.107.209'
                        },
                        {
                            id:"1",
                            title:"Freight Amigo",
                            link:'119.23.107.209'
                        },
                        {
                            id:"2",
                            title:'Shipto',
                            link:'119.23.107.209'
                        }
                    ]
                },
                {
                    id:'2',
                    tittle:"為何有運費調整?為什最終收費和預算收費不同?",
                    links:[
                        {
                            id:"0",
                            title:"Jumppoint",
                            link:'119.23.107.209'
                        },
                        {
                            id:"1",
                            title:"Freight Amigo",
                            link:'119.23.107.209'
                        },
                        {
                            id:"2",
                            title:'Shipto',
                            link:'119.23.107.209'
                        }
                    ],
                    rows:[
                        {
                            id:"0",
                            text:"所有即時報價都是預算報價・最终收費視乎快慿公司貨物量度貨物際體積及重量"
                        }
                    ]
                },
                {
                    id:"3",
                    tittle:"運費以外還有可能需要支付其他額外費用嗎??",
                    links:[
                        {
                            id:"0",
                            title:"Jumppoint",
                            link:'119.23.107.209'
                        },
                        {
                            id:"1",
                            title:"Freight Amigo",
                            link:'119.23.107.209'
                        },
                        {
                            id:"2",
                            title:'Shipto',
                            link:'119.23.107.209'
                        }
                    ],
                    rows:[
                        {
                            id:"1",
                            text:"A.運費以外,以下情况有可能淆生額外費用稅:",
                            children:[
                                {
                                    id:"0",
                                    text:"關稅是當地海按當地法例對郵件進行評稅、征稅的執法過程,當地海有可能授權快遞公司代為征收。無論你的寄件物品是甚麽,你的郵件都必須通過進口流程,並由收件地國家的海按法"
                                },
                                {
                                    id:"1",
                                    text:"律去決定是否需要繳税及需要付的税額由於所有關税細節均是由收件地海決定,税額的詳情要待郵件抵違收件國家後才能確認。"
                                }
                            ]
                        },
                        {
                            id:"2",
                            text:"B.退運費用:",
                            children:[
                                {
                                    id:"0",
                                    text:"如因任何原因終止郵件運送或需要將郵件退回寄件人,寄件人需要支付郵件回程所淅生的所有費用"
                                },
                            ]
                        },
                        {
                            id:"333",
                            text:"C.销毀費、罰款、手、行政費",
                            children:[
                            ]
                        },
                        {
                            id:"4",
                            text:"D.額外補充:運調整並追收或退回差額",
                            children:[
                                {
                                    id:"0",
                                    text:`侍你的郵件完成運送後快公司需時34星期不等與 jumppoint進行運貴調整・當我
                                            們收到快公司的報告後,便會向信用卡追收或退回差額,並同時發出最終運費收據到
                                            你的電郵此時整個交易過程才算正式完結。`
                                },
                                {
                                    id:"1",
                                    text:`如你的郵件於運送過程中淆生任何額外費用(例如由快公司收取的臨時繁忙時期或特殊
                                            情況下的手貴、行政費漏報物品罰款等等) jumppoint會向你收取相費用並於最
                                            終收據中列明`
                                },
                                {
                                    id:"2",
                                    text:`如你收到最终運貴收據後對收貴有不明白/異的地方·請向 jumppoint客服查均
                                        jumppoint會為你向快週公司跟進。`
                                }
                            ]
                        },
                    ]
                }
            ]
        }
    },
    methods: {
        // 监听用户切换tab栏
        changeTab(index){
            this.tabActive = index
        },
    },
    watch:{
        // 监视路由改变
        $route(to,from){
            this.tabActive = this.$route.params.tabIndex + ''
        },
    }
}
</script>

<style lang="less">
    #mailTeaching{
        min-height: 600px;
        .head{
            background-color: #F2F2F2;
            padding-top:130px;
            padding-bottom:20px;
            border-bottom:1px solid #ccc;
            .h{
                font-weight: 600;
                font-size: 23px;
            }
            .tabs{
                display: flex;
                .item{
                    margin-right: 70px;
                    .h{
                        font-size: 17px;
                        font-weight: 550;
                        &:hover{
                            cursor: pointer;
                            opacity: .8;
                        }
                    }
                }
                .item.active{
                    .h{
                        color: @colorMain;
                        font-size:18px;
                    }
                }
            }
        }
        .head>.pubw{
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .body{
            .pubw{
                padding-top: 50px;
                padding-bottom: 150px;
                .item{
                    line-height: 40px;
                    .tiltle{
                        width: 100%;
                        text-align:center;
                        font-size:30px;
                        font-weight:600;
                        border-bottom:2px solid #ccc;
                        padding: 30px 0;
                        margin-bottom: 30px;
                    }
                    .descriptions{
                        span{
                            font-size:17px;
                            font-weight:600;
                        }
                    }
                    .links{
                        display: none;
                        .link{
                            a{
                                color:@colorMain;
                                border-bottom: 2px solid @colorMain;
                                padding-bottom: 5px;
                                font-weight:600;
                                font-size:17px;
                            }
                        }
                    }
                    .rows{
                        .row{
                            li{
                                font-size: 17px;
                                font-weight:600;
                                line-height:25px;
                                margin:15px 0;
                            }
                            .subRow{
                                margin-left: 30px;
                                list-style: disc !important;
                            }
                        }
                    }
                }
                .FQA{
                    .item{
                        .el-row{
                            .el-col{
                                a{
                                    color:@colorMain;
                                    font-weight:600;
                                    font-size:17px;
                                    border-bottom: none;
                                }
                                li{
                                    list-style: none;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>